var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUpFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8433 15.1461L12.3776 8.14688C12.328 8.10032 12.2692 8.06338 12.2044 8.03818C12.1396 8.01297 12.0701 8 12 8C11.9299 8 11.8604 8.01297 11.7956 8.03818C11.7308 8.06338 11.672 8.10032 11.6224 8.14688L4.15667 15.1461C4.0819 15.216 4.03095 15.3052 4.0103 15.4023C3.98964 15.4994 4.00021 15.6 4.04065 15.6915C4.08109 15.783 4.14958 15.8611 4.23746 15.916C4.32533 15.971 4.42861 16.0002 4.53422 16H19.4658C19.5714 16.0002 19.6747 15.971 19.7625 15.916C19.8504 15.8611 19.9189 15.783 19.9594 15.6915C19.9998 15.6 20.0104 15.4994 19.9897 15.4023C19.969 15.3052 19.9181 15.216 19.8433 15.1461Z",
    fill: "#141414"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpFilled);
export default __webpack_public_path__ + "static/media/ChevronUpFilled.53009e7adf66c4acbea7663de9e597f0.svg";
export { ForwardRef as ReactComponent };